// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { NotificationProps } from './notificator-component';

export const INITIAL_STATE: { notifications: NotificationProps[] } = {
  notifications: [],
};
